import { AxiosError, isAxiosError } from 'axios';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseError(error: any, localizationPrefix: string = '', defaultError: string = 'common.errors.base') {
  if (localizationPrefix) {
    localizationPrefix = `${localizationPrefix}.`;
  }
  if (!(error instanceof Error)) {
    return new Error(`${localizationPrefix}${defaultError}`);
  }
  if (!isAxiosError(error) || !error.response) {
    return error;
  }

  if (!isServerError(error)) {
    return error;
  }

  if (typeof error.response.data === 'string') {
    return new Error(error.response.data);
  }
  if (typeof error.response.data.title === 'string') {
    return new Error(`${localizationPrefix}${error.response.data.title}`);
  }

  const errorData = error.response.data;

  return new Error(errorData.detail ?? errorData.title);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isServerError(error: any): error is AxiosError<ServerErrorData, any> {
  if (!isAxiosError(error) || !error.response) {
    return false;
  }

  return !!error.response.data;
}

type ServerErrorData = {
  status: number;
  type: string;
  title: string;
  detail?: string;
  instance: string;
};
